import { createApp } from 'vue'
import App from '@/CheckoutApp.vue'
import router from '@/router/checkout.js'
import FlagIcon from 'vue-flag-icon'
import { ErrorService } from "@/components/ErrorService.vue";

const app = createApp(App)
app.config.errorHandler = (err, vm, info) => {
    ErrorService.handleError(err, vm, info);
};
app.use(router)
app.use(FlagIcon)
app.mount('#app')